/* eslint-disable no-loop-func */
/* eslint-disable camelcase */

function cartUpdated() {
  const { $ } = window;
  const {
    cart_rendered,
    restriction_values,
    restriction_groups,
    button_cart_page,
    button_cart_pop_enabled,
    button_cart_pop_disabled,
    button_cart_top,
  } = window.purchase_limited;

  const restriction_arr = [];
  for (let index = 0; index < restriction_values.length; index++) {
    const restriction_value = restriction_values[index].split('*');
    const payload = {
      group: restriction_value[0],
      sku: restriction_value[1],
      product_limit: restriction_value[2],
      global_limit: restriction_value[3],
      notice: restriction_value[4],
      group_pack: restriction_value[5],
      notice_pack: restriction_value[6],
    };
    restriction_arr.push(payload);
  }
  $.get('/cart?view=json', (response) => {
    const response_json = JSON.parse(response)
    const notices = {};
    let limited = false;
    for (let index = 0; index < restriction_groups.length; index++) {
      let global_count = 0;
      let includes_pack = false;
      restriction_arr.forEach((item, x) => {
        if (item.group == restriction_groups[index]) {
          for (let y = 0; y < response_json.items.length; y++) {
            if (response_json.items[y].sku == item.sku) {
              global_count += response_json.items[y].quantity;
              if (item.group_pack == "true") {
                includes_pack = true;
              }
              if (response_json.items[y].quantity > item.product_limit) {
                limited = true;
                notices[response_json.items[y].variant_id] = {
                  notice: item.notice,
                };
              }
            }
          }
        }
        if (global_count > item.global_limit) {
            limited = true;
            restriction_arr.forEach(function (item, x){
                if(item.group == restriction_groups[index]){
                    for (let y = 0; y < response_json.items.length; y++) {
                        if (response_json.items[y].sku == item.sku) {
                            notices[response_json.items[y].variant_id] = {
                                notice: item.notice
                            }
                        }
                    }
                }
            })
        }
        if (includes_pack == true) {
            pack_list = {};
            restriction_arr.forEach(function (item, x){
            if(item.group == restriction_groups[index]){
                for (let y = 0; y < response_json.items.length; y++) {
                        if (response_json.items[y].sku == item.sku) {
                            if(item.group_pack != "true"){
                                pack_list[response_json.items[y].variant_id] = {
                                    title:response_json.items[y].title
                                }
                                notices[response_json.items[y].variant_id] = {
                                    notice: item.notice
                                }
                            }

                        }
                    }
                }
            })
            var pack_list_keys = Object.keys(pack_list);
            if(pack_list_keys.length > 0){
                limited = true;
                restriction_arr.forEach(function (item, x){
                    if(item.group == restriction_groups[index]){
                        for (let y = 0; y < response_json.items.length; y++) {
                            if (response_json.items[y].sku == item.sku) {
                                if(item.group_pack == "true"){
                                    pack_list_html = '<ul>';
                                    for (var key of pack_list_keys) {
                                        pack_list_html += '<li>' + pack_list[key].title + '</li>';
                                    }
                                    pack_list_html += '</ul>';
                                    pack_list[response_json.items[y].variant_id] = response_json.items[y].title;
                                    notices[response_json.items[y].variant_id] = {
                                        notice: item.notice_pack + pack_list_html
                                    }
                                } else {
                                    notices[response_json.items[y].variant_id] = {
                                        notice: ''
                                    }
                                }

                            }
                        }
                    }
                })
          } 
        }
      });
    }
    if (limited == false) {
      $('#checkoutLinkContainer').html(button_cart_page);
      $('#checkoutLinkContainerPop').html(button_cart_pop_enabled);
      console.log($('checkoutLinkContainer'));
      $('#checkoutLinkContainerTop').html(button_cart_top);
    } else {
      $('#checkoutLinkContainerPop').html(button_cart_pop_disabled);
      $('#checkoutLinkContainer').html('');
      console.log($('checkoutLinkContainer'));
      $('#checkoutLinkContainerTop').html('');
    }
    setNotice(notices)
  })
}
function setNotice(notices) {
  const keys = Object.keys(notices)
  if (keys.length > 0) {
    // eslint-disable-next-line no-restricted-syntax
    for (const key of keys) {
      $(`*[data-cart-item-with-variants="${key}"]`)
        .find('.cart--title-container')
        .append(`<div class="column xsmall-medium--12 large--12 cart--item-limited">'${notices[key].notice}</div>`);
    }
  } else {
    $('.cart--item-limited').each((e) => {
      $(e).remove();
    });
  }
}
document.addEventListener('cart:rendered', cartUpdated);
